import type { FaireProductEntity } from "../../entity_types/product";

export const p_y2kd4e2vfx: FaireProductEntity = {
  token: "p_y2kd4e2vfx",
  type: "product",
  name: "The Dog Oracle",
  brandToken: "b_bomzcs63",
  brandName: "Hachette Book Group",
  imageUrl: "https://cdn.faire.com/fastly/538ccc51f9d6f1ab89c1e20ee14831be92ba22c85c909ef843ff9e77a1daf37f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9c515784c3290ddba5f243a19e6dfc71b9d9db1ad11c3ce2fd85f1c1d9e78050.jpeg",
    "https://cdn.faire.com/fastly/d85545f37539741006a5c376a47fa035112c564d2838647aabc21f3c299f0287.jpeg",
    "https://cdn.faire.com/fastly/cb9a1a5e25c495efc900a8a654fff22e991827a5de1046175057e5e85ff85bbc.jpeg",
    "https://cdn.faire.com/fastly/6b75b46c4e97d9f0c3c422acc531d1a014e9d8b736d74dce1fdbd7baa4db23ac.jpeg"
  ],
  priceDollars: 7,
  description: "Discover guidance and clarity on life’s biggest questions with this book of answers and wisdom from Spud the Cryptid, the internet’s cute and chaotic canine prophet.\nSeek wisdom. Receive chaos.\n\nHave a burning question about life, love or whether celery is friend or foe? Seek the ancient – and slightly unhinged – wisdom of Spud the Cryptid, the internet’s most peculiar oracle.\n\nSimply hold The Dog Oracle in your hands, focus your mind, ask your question aloud and open to a random page. There you’ll find Spud – philosopher, sage and unapologetic weirdo – ready to bless you with cryptic canine insight. Perhaps she’s gazing into the void. Maybe she’s eating grass. Either way, her message is (probably) clear.\n\nPacked with baffling pearls of wisdom and the chaotic charm that has made Spud a cult favorite online, The Dog Oracle is here to help you answer life’s toughest questions and celebrate this most mysterious prophet. It’s the perfect book for anyone who has ever looked into a dog’s eyes and thought, “What do they know that I don’t?”\n\nApproach with an open mind – and maybe a treat.",
  tags: [],
  msrpDollars: 13.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:06:57.890Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
